import ApiService from './ApiService'

export default class AIChatService {
  constructor() {
    this.apiService = new ApiService()
  }

  async sendMessage(messageData) {
    try {
      const response = await this.apiService.post(
        'aichat/message',
        messageData,
        null,
        true,
        false
      )
      return response
    } catch (error) {
      console.error('Error sending AI chat message:', error)
      throw error
    }
  }

  async getChatHistory(sessionId, page = 1, pageSize = 50) {
    try {
      const response = await this.apiService.get(
        'aichat/history',
        {
          sessionId,
          page,
          pageSize,
        },
        true,
        false
      )
      return response
    } catch (error) {
      console.error('Error getting AI chat history:', error)
      throw error
    }
  }

  async getChatSessions(page = 1, pageSize = 20) {
    try {
      const response = await this.apiService.get(
        'aichat/sessions',
        {
          page,
          pageSize,
        },
        true,
        false
      )
      return response
    } catch (error) {
      console.error('Error getting AI chat sessions:', error)
      throw error
    }
  }

  async deleteChatSession(sessionId) {
    try {
      const response = await this.apiService.delete(
        `aichat/session/${sessionId}`,
        null,
        true,
        false
      )
      return response
    } catch (error) {
      console.error('Error deleting AI chat session:', error)
      throw error
    }
  }

  async getStatistics() {
    try {
      const response = await this.apiService.get(
        'aichat/statistics',
        null,
        true,
        false
      )
      return response
    } catch (error) {
      console.error('Error getting AI chat statistics:', error)
      throw error
    }
  }
}
